import React from "react";

import "./resource_plan_overview_page.less";
import { Headline } from "@src/components";
import { ResourcePlanOverviewTable } from "@src/features/resource_plan_overview/components/resource_plan_overview_table";

const ResourcePlanOverviewPage: React.FC = () => {
  return (
    <div className="resource_plan_overview_page">
      <div className="header-section">
        <Headline title="Resource plans" />
      </div>

      <ResourcePlanOverviewTable />
    </div>
  );
};

export default ResourcePlanOverviewPage;
